SourceHireAddFilterDropdownComponent.$inject = ['$element', '$timeout'];

function SourceHireAddFilterDropdownComponent($element, $timeout) {
    var self = this;

    self.toggleFilter = function (event, filterItem) {
        filterItem.selected = !filterItem.selected;
        $timeout(() => {
            self.onToggleFilter({filterCode: filterItem[self.filterKey]});
        });
    };

    self.$onDestroy = function () {
        $(window).off('resize');
    };

}

angular
    .module("harriApp")
    .component("sourceHireAddFilterDropdownComponent", {
        controller: SourceHireAddFilterDropdownComponent,
        bindings: {
            filters: '<',
            filterKey: '<',
            selectedFilters: '<',
            onToggleFilter: '&',
        },
        controllerAs: '$ctrl',
        templateUrl: '../hmodules/harri-main/components/source-hire-add-filter-dropdown/source-hire-add-filter-dropdown.component.ng.html'
    });
